function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2445.811 -2821.851)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.018,
  cy: 16.018,
  r: 16.018,
  transform: "translate(2445.811 2821.851)",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2464.932,2848.509v-2h-2v-2h1.234a2,2,0,0,0,1.985-1.752l.031-.248h2.308a2,2,0,0,0,1.9-1.368l1.544-4.632h-5l1-8h-12l1,8h-5l1.544,4.632a2,2,0,0,0,1.9,1.368h2.309l.031.248a2,2,0,0,0,1.984,1.752h1.235v2h-2v2Zm-9.895-8.684-.439-1.316h2.584l.25,2h-1.446A1,1,0,0,1,2455.037,2839.825Zm4.535,1.808-1.39-11.124h7.5l-1.391,11.124a1,1,0,0,1-.992.876h-2.734A1,1,0,0,1,2459.572,2841.633Zm6.86-1.124.25-2h2.583l-.439,1.316a1,1,0,0,1-.948.684Z",
  fill: "#b40000"
}));

var SvgFirstPlace = function SvgFirstPlace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.037,
    height: 32.037,
    viewBox: "0 0 32.037 32.037",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirstPlace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/first-place.5e54ba17.svg";
export { ForwardRef as ReactComponent };